import FormModal from '../../../Modals/FormModal';
import DesktopTableInlineActions from '../../../Tables/desktop/DesktopTableInlineActions';
import InventoryAdjustmentStatusBar from '../statusBar/AdjustmentStatusBar';
import InventoryAdjustmentHeader from '../headers/InventoryAdjustmentHeader';
import { useInventoryAdjustment } from '../../../../hooks/inventory/useInventoryAdjustment';
import { adjustmentProductColumns } from './columns/adjustmentProductColumns';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const InventoryAdjustmentDetailModal = ({ isOpen, onClose }: Props) => {
  const { form, clearForm } = useInventoryAdjustment();

  const handleClose = () => {
    clearForm();
    onClose();
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={handleClose}
      title="Detalle de Ajuste de Inventario"
      maxWidth="max-w-6xl"
      zIndex="normal"
    >
      {/* ───────── HEADER (solo lectura) ───────── */}
      <InventoryAdjustmentHeader
        branchId={form.branchId}
        reason={form.reason}
        readOnly
      />

      {/* ───────── STATUS BAR ───────── */}
      <InventoryAdjustmentStatusBar
        status={form.status}
        adjustedDate={form.adjustedDate}
        adjustedTime={form.adjustedTime}
      />

      {/* ───────── DETAILS TABLE ───────── */}
      <div className="mb-6 px-4">
        <h3 className="mb-3 text-base font-semibold">
          Productos Ajustados
        </h3>

        <DesktopTableInlineActions
          columns={adjustmentProductColumns}
          data={form.details}
          actions={undefined} // 🔒 SIN acciones
          noDataMessage="No hay productos en este ajuste."
        />
      </div>

      {/* ───────── FOOTER ───────── */}
      <div className="flex justify-end gap-3 px-4">
        <button
          type="button"
          onClick={handleClose}
          className="inline-flex rounded-md bg-primary px-5 py-2.5 text-sm font-medium text-white hover:bg-opacity-90"
        >
          Cerrar
        </button>
      </div>
    </FormModal>
  );
};

export default InventoryAdjustmentDetailModal;
